/*eslint-disable */
import React from "react";

declare const window: any;
const CatalogoComponent: React.FC = () => {
  return (
    <div className="catalogo-posventa-repuestos-container">
      {/* H2 - Título principal (comentado pero disponible) */}
      {/* <h2 className="title-catalogo-posventa-repuestos-container">Busca y adquiere repuestos genuinos para tu Hyundai</h2> */}
      
      {/* H3 - Subtítulo */}
      <h3 className="subtitle-catalogo-posventa-repuestos-container">
        A través de nuestro distribuidor autorizado
      </h3>

      <a 
        href="https://www.imotriz.com/tienda/repuestos-hyundai/" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="btn-catalogo-posventa-repuestos-container"
      >
        Ver catálogo
      </a>
    </div>
  );
};

export default CatalogoComponent;